var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { alpha, Box } from "@mui/material";
import React from "react";
export const DCard = (_a) => {
    var { children, sx } = _a, other = __rest(_a, ["children", "sx"]);
    return (React.createElement(Box, Object.assign({ sx: Object.assign({ border: "1px solid", borderRadius: 1.75, px: 2, borderColor: (theme) => alpha(theme.palette.primary.main, 0.16), bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08) }, sx) }, other), children));
};
